__turbopack_context__.v({
  "button": "ExpandableImage-module__FoUa7G__button",
  "container": "ExpandableImage-module__FoUa7G__container",
  "img": "ExpandableImage-module__FoUa7G__img",
});
